<!-- eslint-disable -->
<template>
    <div class="list-container">
        <el-row>
            <el-col :span="18" style="text-align:left">
                <el-form :model="params" :inline="true" size="small">
                    <el-form-item label="关键词类型：">
                        <el-select v-model="params.search[0].key" clearable>
                            <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="关键词：">
                        <el-input v-model="params.search[0].value" placeholder="请输入关键词" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" plain @click="searchQuiz">搜索</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="6" style="text-align:right">
                <el-button type="primary" @click="toAddQuiz" size="small">添加quiz</el-button>
            </el-col>
        </el-row>
        <el-table :data="tableData" :height="height" size="small">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="table-expand">
                        <el-form-item label="intro页文案">
                            <span>{{ props.row.quiz_intro_info }}</span>
                        </el-form-item>
                        <div v-for="(item, index) in props.row.question_list" :key="index">
                            <el-form-item class="split-line" :label="`题目${index + 1}`">
                                <span>{{ item.quiz_question }}</span>
                            </el-form-item>
                            <el-form-item class="half-line" :label="`题目${index + 1}对应选项`">
                                <span class="wrap-span">{{ item.option_list_string }}</span>
                            </el-form-item>
                            <el-form-item class="half-line" :label="`题目${index + 1}对应选项分数`">
                                <span class="wrap-span">{{ item.option_score_list_string }}</span>
                            </el-form-item>
                        </div>
                        <el-form-item class="split-line" label="答案">
                            <span class="wrap-span">{{ props.row.quiz_answer }}</span>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>
            <el-table-column prop="article_id" label="ID" width="90"></el-table-column>
            <el-table-column v-if="is_administrators" label="Status" width="100">
                <template slot-scope="scope">
                    <el-switch
                        v-model="scope.row.status"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        @change="changeQuizStatus(scope.row.status,scope.row.article_id)"
                    >
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column label="Banner图" width="130">
                <template slot-scope="scope">
                    <img :src="scope.row.banner_image" class="banner-image" />
                </template>
            </el-table-column>
            <el-table-column prop="quiz_title" label="标题"></el-table-column>
            <el-table-column prop="category_name" label="分类" width="110"></el-table-column>
            <el-table-column prop="tag_one_name" label="Tag1" width="110"></el-table-column>
            <el-table-column prop="tag_two_name" label="Tag2" width="110"></el-table-column>
            <el-table-column prop="tag_three_custom" label="Tag3(自定义)" width="180"></el-table-column>
            <el-table-column prop="update_at" label="更新时间" width="150"></el-table-column>
            <el-table-column v-if="is_administrators" fixed="right" label="操作" width="80">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="editQuiz(scope.row)">
                        编辑
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="bottom-pagination">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="params.current_page"
                :total="total"
                :page-sizes="[10, 15, 30]"
                :page-size="params.page_size"
                layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </div>
    </div>
</template>
<!-- eslint-disable -->

<script>
import {formConvertFormat} from '../../common/tools';
export default {
    name: 'QuizList',
    data() {
        return {
            is_administrators: 0, // 是否是审核账号
            type: 0, // 表格类型 1为编辑 0为新增
            height: window.innerHeight - 200, // 计算表格的高度
            tableData: [], // 列表数据
            total: 0, // 数据总条数
            params: { // 获取列表参数
                current_page: 1,
                page_size: 15,
                search: [
                    {
                        key: '',
                        value: ''
                    }
                ],
                showLoading: true
            },
            // 选项列表（必选）
            options: [ // 搜索下拉框数据
                {
                    value: 'quiz_id',
                    label: 'quizID'
                },
                {
                    value: 'quiz_title',
                    label: 'quiz名称'
                }
            ]
        };
    },
    mounted() {
        this.is_administrators = window.localStorage.getItem('is_administrators') === '1' ? 1 : 0;
        this.getQuizList();
    },
    methods: {
        formConvertFormat,
        // 处理切换每页显示条数
        handleSizeChange(val) {
            this.params.page_size = val;
            this.getQuizList();
        },
        // 处理切换页码
        handleCurrentChange(val) {
            this.params.current_page = val;
            this.getQuizList();
        },
        getQuizList() {
            this.$axios(this.path.getQuizList(this.params))
                .then(res => {
                    this.total = res.data.total;
                    let articleListArr = [];
                    res.data.article_list.forEach(item => {
                        articleListArr.push(this.formConvertFormat(item, 'list'));
                    });
                    this.tableData = articleListArr;
                });
        },
        searchQuiz() {
            console.log('关键词搜索quiz');
        },
        toAddQuiz() {
            this.$emit('toEditQuiz', 0);
        },
        editQuiz(row) {
            this.$emit('toEditQuiz', row.article_id);
        },
        changeQuizStatus(val,id) {
            let res = val ? 1 : 0;
            console.log('改变quiz状态', id, res);
            this.$axios(this.path.changeStatus(res,id))
        }
    }
};
</script>

<style lang="less" scoped>
.list-container {
    .el-table  {
        .table-expand {
            font-size: 0;
            /deep/label {
                width: 186px;
                color: #869fc0;
            }
            .el-form-item {
                margin: 0 0 12px 58px;
                width: calc(100% - 58px);
                /deep/.el-form-item__content {
                    max-width: calc(100% - 200px);
                }
                &.half-line {
                    width: calc(50% - 58px);
                }
                .wrap-span {
                    white-space: pre-wrap;
                }
            }
            .split-line {
                border-top: 1px solid #eee;
            }
        }
        .banner-image {
            width: 100%;
        }
    }
    .bottom-pagination {
        position: absolute;
        bottom: 20px;
        right: 16px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/quiz-list/index.vue